module.exports = __webpack_public_path__ + "media/leather_1.9bf21d2c.webm";